import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Select } from 'shared/components';
import { cloneDeep } from 'lodash';

class AssignSeat extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  handleChange(e) {
    e.stopPropagation();
    if (!isNaN(+e.target.value)) {
      this.props.handleClick(e.target.value);
    } else {
      this.props.handleClick();
    }
  }

  handleClick() {
    this.props.handleClick();
  }

  render() {
    const { data, availableBooklets } = this.props;

    const booklets = cloneDeep(availableBooklets);

    if (data && data.serialNumber) {
      booklets.push(data.serialNumber);
      booklets.sort((x, y) => x - y);
    }
    booklets.unshift('Unassign');

    return (
      <div
        className={`cell assign ${!data.serialNumber ? 'empty-seat' : ''}`}
        onClick={this.handleClick}>
        {data.serialNumber ? (
          <Select
            options={booklets.map((x) => ({ value: x, label: x }))}
            value={data.serialNumber}
            name="booklets"
            onChange={(e) => this.handleChange(e)}
            onClick={(e) => {
              e.stopPropagation();
              e.nativeEvent.stopImmediatePropagation();
            }}
            ref={(component) => {
              this.selectComponent = component;
            }}
          />
        ) : (
          this.props.t('seatingChart.assign.bookletLabel')
        )}
      </div>
    );
  }
}

export default withTranslation()(AssignSeat);
AssignSeat.propTypes = {
  availableBooklets: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.shape({}).isRequired,
  handleClick: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};
